<template>
  <div>
    <!-- tab -->
    <v-tabs v-model="tab" color="primary" grow>
      <v-tab v-for="(item, i) in tabList" :key="item">
        <div v-if="i === 0">
        {{ item }}
        </div>
      </v-tab>
    </v-tabs>

    <!-- tab contents -->
    <v-tabs-items v-model="tab">
      <!-- [tab1] 전체 -->
      <v-tab-item class="pt-5 px-6 pb-8 overflow-y-auto">
        <v-list
          v-for="appMenuObj in appMenuList"
          :key="appMenuObj.categoryCd"
          class="app-menu"
        >
          <v-subheader class="px-0">{{ appMenuObj.categoryNm }}</v-subheader>
          <application-menu-list
            :menuList="appMenuObj.applMenuList"
          ></application-menu-list>
        </v-list>
      </v-tab-item>

      <!-- [tab2] 자주 쓰는 신청서 -->
      <!--
      <v-tab-item class="pt-5 px-6 pb-8 pb-8 overflow-y-auto">
        <v-list class="app-menu">
          <application-menu-list
            :menuList="bookmarkList"
          ></application-menu-list>
        </v-list>
      </v-tab-item>
      -->
    </v-tabs-items>
  </div>
</template>

<script>
/* 신청서메뉴 */
import ApplicationMenuList from '@/components/application/menu/ApplicationMenuList.vue';

import { getMobileApplMenu, getMobileApplBookmarkMenu } from '@/api/ela.js';
import { mapMutations } from 'vuex';

export default {
  data: () => ({
    tab: null,
    tabList: ['전체', '자주 쓰는 신청서'],

    appMenuList: [],
    bookmarkList: [],
  }),

  computed: {
    GET_USER_DATA() {
      return this.$store.getters.GET_USER_DATA;
    },
  },

  methods: {
    ...mapMutations('SPINNER', ['ON_APP_SPINNER', 'OFF_APP_SPINNER']),

    /* 신청서메뉴조회 */
    async fetchAppMenu() {

      const pRefUseYn = this.$store.getters.GET_USER_DATA.ssnStatusCd == 'CA' ? 'Y' : 'N';
      // (1) 신청서전체메뉴 조회
      try {
        let params = {
          refUseYn: pRefUseYn,
        }
        const response = await getMobileApplMenu(params);
        // console.log('response ::: ' + JSON.stringify(response));
        const responseData = response.data.data;
        this.appMenuList = responseData;
      } catch (error) {
        console.log(error);
      }

      // (2) 자주쓰는신청서메뉴 조회
      try {
        const response = await getMobileApplBookmarkMenu();
        const responseData = response.data.data;
        this.bookmarkList = responseData;
      } catch (error) {
        console.log(error);
      }

      this.OFF_APP_SPINNER(); // 스피너 OFF
    },
  },

  created() {
    this.ON_APP_SPINNER(); // 스피너 ON
    this.fetchAppMenu();
  },

  mounted() {
    // 접근시 state 초기화
    this.$store.commit('ELA/RESET_ELA_STATE');
    this.$store.commit('ELA/RESET_APPLICATION_STATE');
  },

  components: {
    ApplicationMenuList,
  },
};
</script>
